import type {
  PaymentAccountStatus,
  PaymentProviderAccount,
} from "schemas/generated/paymentProvider";
import type { AutomaticTaxStatus } from "schemas/paymentProvider";
import type { RequestFn } from "./request";

export function createPaymentProviderAccountClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    setUp: ({
      projectId,
      agentSessionId,
    }: {
      projectId: string;
      // The caller's open chat, round-tripped through Stripe so the onboarding
      // bounce can land the merchant back in it.
      agentSessionId: string | null;
    }) => {
      return request<{ onboardingUrl: string }>({
        method: "POST",
        path: `/api/v1/projects/${projectId}/payment-provider-account/setup`,
        query: { agentSessionId: agentSessionId ?? undefined },
      });
    },
    createFinishSetupLink: ({
      projectId,
      agentSessionId,
    }: {
      projectId: string;
      agentSessionId: string | null;
    }) => {
      return request<{ url: string }>({
        method: "POST",
        path: `/api/v1/projects/${projectId}/payment-provider-account/finish-setup-link`,
        query: { agentSessionId: agentSessionId ?? undefined },
      });
    },
    createDashboardLink: ({ projectId }: { projectId: string }) => {
      return request<{ url: string }>({
        method: "POST",
        path: `/api/v1/projects/${projectId}/payment-provider-account/dashboard-link`,
      });
    },
    getAccount: ({ projectId }: { projectId: string }) => {
      return request<{
        account: PaymentProviderAccount | null;
        status: PaymentAccountStatus;
      }>({
        method: "GET",
        path: `/api/v1/projects/${projectId}/payment-provider-account`,
      });
    },
    getTaxStatus: ({ projectId }: { projectId: string }) => {
      return request<{ taxStatus: AutomaticTaxStatus }>({
        method: "GET",
        path: `/api/v1/projects/${projectId}/payment-provider-account/tax-status`,
      });
    },
    disconnect: ({ projectId }: { projectId: string }) => {
      return request<{ success: boolean }>({
        method: "POST",
        path: `/api/v1/projects/${projectId}/payment-provider-account/disconnect`,
      });
    },
  };
}
